import { camelCase, capitalize } from "lodash-es";
import { memo } from "react";

import * as icons from "~/assets/svgs";

import type { IconName, SVGComponentProps } from "~/types/shared";

export type IconProps = SVGComponentProps & {
  name: Uppercase<IconName>;
};

export type UppercaseIconName = Uppercase<IconName>;

export const transformIconName = (input: string): UppercaseIconName => {
  return capitalize(camelCase(input)) as UppercaseIconName;
};

export const Icon = memo(({ name, className, ...restProps }: IconProps) => {
  const key = transformIconName(name);
  // eslint-disable-next-line import/namespace
  const IconComponent = icons[key as IconName];

  if (!IconComponent) {
    throw new Error(`Icon not found for key: ${key}`);
    return null;
  }

  return <IconComponent {...restProps} className={className} />;
});
